<template>
	<div class="layout-wrapper layout-content-navbar">
		<div class="layout-container">
			<!-- Menu Component -->
			<Menu :isGroupAdmin="isGroupAdmin" />
			
			<!-- Layout container -->
			<div
				:class="isMenuExpanded ? 'layout-page' : 'layout-page'"
			>
				<nav
					class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
					id="layout-navbar">
					<div class="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
						<a class="nav-item nav-link px-0 me-xl-6" @click="toggleMenu()">
							<i class="ri-menu-fill ri-22px"></i>
						</a>
					</div>

					<div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
						<ul class="navbar-nav flex-row align-items-center ms-auto" style="padding-right: 24px;">
							<!-- User -->
							<li class="nav-item navbar-dropdown dropdown-user dropdown">
								<a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
									<div class="avatar avatar">
										<span class="avatar-initial rounded-circle bg-label-primary">
											{{ getInitials() }}
										</span>
									</div>
								</a>
								<ul class="dropdown-menu dropdown-menu-end">
									<li>
										<a class="dropdown-item" href="#">
											<div class="d-flex">
												<div class="flex-shrink-0 me-2">
													<div class="avatar avatar">
														<span class="avatar-initial rounded-circle bg-label-primary">
															AP
														</span>
													</div>
												</div>
												<div class="flex-grow-1" v-if="profile">
													<span class="fw-medium d-block">
														{{ profile.firstName }} {{ profile.lastName }}
													</span>
													<small class="text-muted">Manager</small>
												</div>
											</div>
										</a>
									</li>
									<li>
										<div class="dropdown-divider"></div>
									</li>
									<li>
										<router-link to="/settings" class="dropdown-item">
											<i class="ri-settings-4-line me-3"></i><span class="align-middle">Réglages</span>
										</router-link>
									</li>
									<li>
										<a class="dropdown-item" href="javascript:void(0);" @click="logout()">
											<i class="ri-shut-down-line me-3"></i>
											<span class="align-middle">Se déconnecter</span>
										</a>
									</li>
								</ul>
							</li>
							<!--/ User -->
						</ul>
					</div>
				</nav>

				<div class="layout-overlay layout-menu-toggle"></div>

				<!-- Content wrapper -->
				<div class="content-wrapper">
					<div class="container-xxl flex-grow-1 container-p-y">
						<!-- Vue Router View -->
						<router-view />
					</div>
				</div>

				<!-- Footer Component -->
				<Footer />
			</div>
		</div>
	</div>
</template>

<script>
import Dropdown from 'bootstrap/js/dist/dropdown'

import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";

import HTTP from "@/axios";

export default {
	name: "DefaultLayout",
	components: {
		Menu,
		Footer,
	},

	data() {
		return {
			profile: null,
		}
	},

	async mounted() {
		// Ajouter dynamiquement les attributs nécessaires à <html> pour le thème
		document.documentElement.setAttribute("lang", "en");
		document.documentElement.setAttribute(
			"class",
			"light-style layout-navbar-fixed layout-menu-fixed layout-compact"
		);
		document.documentElement.setAttribute("dir", "ltr");
		document.documentElement.setAttribute("data-theme", "theme-default");
		document.documentElement.setAttribute(
			"data-template",
			"vertical-menu-template-no-customizer-starter"
		);
		document.documentElement.setAttribute("data-style", "light");

		if (this.$store.getters.isLoggedIn)
			this.fetchProfile();

		const dropdownTriggerList = this.$el.querySelectorAll('[data-bs-toggle="dropdown"]')
		dropdownTriggerList.forEach(el => {
			new Dropdown(el)
		})
	},

	methods: {
		getInitials() {
			if (!this.profile) return '';
			const firstInitial = this.profile.firstName ? this.profile.firstName.trim().charAt(0).toUpperCase() : '';
			const lastInitial = this.profile.lastName ? this.profile.lastName.trim().charAt(0).toUpperCase() : '';
			return firstInitial + lastInitial;
		},

		toggleMenu() {
			this.$store.dispatch("toggleMenu");
		},

		async fetchProfile() {
			try {
				const response = await HTTP(`/user/profile`);
				this.profile = response.data.profile;
				this.isGroupAdmin = response.data.isGroupAdmin;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		logout() {
			if (!confirm("Ëtes vous sur de vouloir vous déconnecter?"))
				return;

			this.$store.dispatch("logout");

			// Setup company
			this.$router.push("/login");
		}
	}
};
</script>
